<script setup lang="ts">
import SharedTrip from "@/models/dto/SharedTrip";
import {URMRoleKey, URMRoles} from "@/models/dto/userRoleManagement";
import {findBestRoleForCustomer, noTeamRoleDisplayText} from "@/utils/urmUtils";
import {computed} from "vue";
import ContactListItemTag from "@/components/Contact/ContactListItemTag.vue";

const props = defineProps<{
  row: SharedTrip,
}>();

const primaryRoleLabel = computed(() => findBestRoleForCustomer(props.row.roles, [URMRoles.TripAuthorizedUser, URMRoles.TripViewOnly])?.label || noTeamRoleDisplayText)
const hasTripContactRole = computed(() => props.row.roles.includes(URMRoleKey.TripContact));
const hasTripEditorRole = computed(() => props.row.roles.includes(URMRoleKey.TripEditor));
</script>

<template>
  <v-container class="pt-2 pb-0 pl-0 pr-0">
    <v-row dense>
      <v-col>
        <span class="text-no-wrap">
          {{ primaryRoleLabel }}
        </span>
      </v-col>
      <v-col v-if="hasTripContactRole" >
        <ContactListItemTag :tag-text="URMRoles.TripContact.label"/>
      </v-col>
    </v-row>
    <v-row dense class="mt-0" v-if="hasTripEditorRole">
      <v-col class="pt-0">
        <span class="font-12 margin-t-0 text-gray-light">
          Can Modify/Cancel
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>
